/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var JoveValidationStatus;

(function (JoveValidationStatus) {
  JoveValidationStatus["IMPORTED"] = "imported";
  JoveValidationStatus["NOT_STARTED"] = "not_started";
  JoveValidationStatus["INVITATION_CREATED"] = "invitation_created";
  JoveValidationStatus["DROPOUT"] = "dropout";
  JoveValidationStatus["CANCELLED"] = "cancelled";
  JoveValidationStatus["IN_PROGRESS"] = "in_progress";
  JoveValidationStatus["FAIL"] = "fail";
  JoveValidationStatus["SUCCESS"] = "success";
  JoveValidationStatus["PAYE_CONTRACTOR"] = "paye_contractor";
})(JoveValidationStatus || (JoveValidationStatus = {}));